/**
 *
 * Asynchronously loads the component for HomePage
 *
 */

import loadable from '../../utils/loadable';
import { SelectionPageProps } from './index';

export default loadable<SelectionPageProps>(() => import('./index'));
